export default __webpack_public_path__ + "static/shrigley-39168b751e3e31e740d6ddc1b9afbd3b.svg";